/**
 * Constants index module.
 */
const DEBUG = process.env.NODE_ENV !== "production";

export { DEBUG };
